import React, { useState, useEffect, useRef } from "react";
import {
  Checkbox,
  Button,
  TextField,
  Typography,
  IconButton,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";

import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import {EDIT_TEAM_TERM} from "../../graphQL/team_term_qry";

var findAnd = require("find-and");

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },

  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 10,
      fontSize: 16,
    },
  },
  errorStyle: {
    marginLeft: 5,
    marginTop: 0,
    fontSize: 14,
    fontFamily: "Arial",
  },
}));

export default function TeamTermInfoInputDialog({ teamTermInf, closeDialog  }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const [open, setOpen] = useState(true);
  const [errorMsg, setErrorMsg] = useState({
    teamTermGoal: ""
  });
  const [teamTermInfo, setTeamTermInfo] = useState(teamTermInf);
  const [teamTermGoal, setTeamTermGoal] = useState(teamTermInf.goal);
  const [updatedTeamTermGoal, setUpdatedTeamTermGoal] = useState(teamTermInf.goal);

  let clientId = 1;
  if (localStorage.getItem("clientId")) clientId = localStorage.getItem("clientId");
  let clientName = "";
  if (localStorage.getItem("clientName")) clientName = localStorage.getItem("clientName");

  const [editTeamTerm] = useMutation(EDIT_TEAM_TERM, {
    awaitRefetchQueries: true,
  });

  function dayFormatSlashSeparated(day) {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    const formatter = new Intl.DateTimeFormat("en-US", options);
    return formatter.format(new Date(day));
  }

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog(updatedTeamTermGoal);
  };

  const handleTeamTermGoalChange = event => {
    if (event.target.value.trim() === "")
      setErrorMsg({ teamTermGoal: "Team Term Goal cannot be blank." });
    else setErrorMsg({ teamTermGoal: "" });
    setTeamTermGoal(event.target.value);
  };  

  const handleSave = async () => {
    if (teamTermGoal.trim() === "") {
      setErrorMsg({ teamTermGoal: "Term Name cannot be blank." });    
    } else {

      const { data, error } = await editTeamTerm({
        variables: {
          teamTermId: parseInt(teamTermInfo.id),
          goal: teamTermGoal, 
        },
      });
      if (error) {
        console.log("Error", error, data);
        alert("Unfortunately an error occurred.");
      } else if (data && data.editTeamTerm) {
        console.log("Success", data);
        setUpdatedTeamTermGoal(data.editTeamTerm.teamTerm.goal);
        setTeamTermGoal(data.editTeamTerm.teamTerm.goal);
        handleClose();
      };
    };
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              width: "100%",
              height: "100%",
              maxWidth: "600px",
              maxHeight: "650px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{
            display: "flex",
            justifyContent: "space-between",
            paddingBottom: 0,
          }}
        >
          <Box mt={1} ml={1}>
            Team Term Info
          </Box>
          {closeDialog ? (
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                align: "right",
                color: theme => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          ) : null}
        </DialogTitle>

        <Box pt={1} pb={1} style={{ display: "flex", justifyContent: "center" }}>
          <Typography variant="h1" style={{ fontSize: 20 }}>
            This team term belongs to client: {clientName}
          </Typography>
        </Box>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              autoFocus
              required
              label="Team Term Goal"
              margin="normal"
              name="teamTermGoal"
              variant="outlined"
              id="teamTermGoal"
              defaultValue={teamTermGoal}
              onChange={handleTeamTermGoalChange}
            />
            {errorMsg && (
              <FormHelperText className={classes.errorStyle} error>
                {errorMsg.teamTermGoal}
              </FormHelperText>
            )}
           
            <TextField
              className={classes.textFieldStyle}
              style={{ paddingRight: 5 }}
              fullWidth
              disabled
              label="Term Name"
              margin="normal"
              name="termName"
              variant="outlined"
              id="termName"
              value={teamTermInfo.termName}
            />
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              disabled
              label="Start Date"
              margin="normal"
              name="startDate"
              variant="outlined"
              id="startDate"
              value={dayFormatSlashSeparated(teamTermInfo.startDate)}
            />
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              disabled
              label="End Date"
              margin="normal"
              name="endDate"
              variant="outlined"
              id="endDate"
              value={dayFormatSlashSeparated(teamTermInfo.endDate)}
            />
            <TextField
              className={classes.textFieldStyle}
              fullWidth
              disabled
              label="No of Weeks"
              margin="normal"
              name="noOfWeeks"
              value={teamTermInfo.noOfWeeks}
              variant="outlined"
              id="noOfWeeks"
            /> 
                     
          </DialogContentText>
        </DialogContent>

        <DialogActions style={{ justifyContent: "center", marginTop: 15 }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5 }}
              onClick={handleSave}
            >
              Save
            </Button>
            <Button
              variant="text"
              color="primary"
              className={classes.outlinedButtonStyle}
              onClick={handleClose}
            >
              Cancel
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
